import { useCallback } from 'react'
import { useControlStore, useSelectionStore } from '@editorStores'
import { useSelectedPlanElementId } from '@editorHooks'
import { useStructuralPlanningSelection } from '@structuralPlanningHooks'
import usePlanElementSelection from './usePlanElementSelection'

const usePlanTableEditMode = () => {
  const { selectPlanElement, clearPlanSelection } = usePlanElementSelection()
  const selectedId = useSelectedPlanElementId('table')
  const setElementListCollapsed = useControlStore(state => state.setElementListCollapsed)
  const selectPlanElementInStore = useSelectionStore(state => state.selectPlanElement)
  const {
    params: { mode },
    actions: { toggleMode },
    modes: { isPlanTableMode },
  } = useStructuralPlanningSelection()

  const enterPlanTableEdit = useCallback(
    (tableId: string) => {
      selectPlanElementInStore(
        { type: 'plan', planElementType: 'table', guid: tableId },
        { mode: 'plan-table' },
      )
      setElementListCollapsed(false)
    },
    [selectPlanElementInStore, setElementListCollapsed],
  )

  // Scene selection: just select the table (shows the in-scene HUD/popup) without
  // switching to plan-table mode, so the right drawer form does not open — matching
  // how selecting a comment in the scene behaves (the form is drawer-list driven).
  const selectPlanTableInScene = useCallback(
    (tableId: string) => {
      selectPlanElement('table', tableId)
    },
    [selectPlanElement],
  )

  const exitPlanTableEdit = useCallback(() => {
    clearPlanSelection()
    if (mode === 'plan-table') toggleMode()
  }, [clearPlanSelection, mode, toggleMode])

  return {
    selectedId,
    isPlanTableMode,
    enterPlanTableEdit,
    selectPlanTableInScene,
    exitPlanTableEdit,
  }
}

export default usePlanTableEditMode
